var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list",
    { attrs: { "two-line": "" } },
    [
      _vm._l(_vm.ordini, function (ord, i) {
        return [
          i > 0 ? _c("v-divider", { key: "d_" + i }) : _vm._e(),
          _c("ItemListOrdineMTM", {
            key: ord.id,
            attrs: { "data-test": "ordine-in-lista-" + i, ordine: ord },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }